<div class="train-data-heading">
    <ul class="list-unstyled">
        <li class="train-loco-count">
            <label>{{trainData && trainData.locoDetails.length}} Locomotives</label>
            <span>Calculated Tonnage Capacity: <b>{{trainData.calculatedTonnage ? trainData.calculatedTonnage : '-'}}</b></span>
        </li>
        <li><label>{{locoLabel.sequence}}</label></li>
        <li class="intended-column"><label>{{locoLabel.intendedUsage}}</label></li>
        <li><label>{{locoLabel.problems}}</label></li>
        <li><label>{{locoLabel.fueledAt}}</label></li>
        <li><label>{{locoLabel.dateFueled}}</label></li>
        <li><label>{{locoLabel.milesToEmpty}}</label></li>
        <li><label>{{locoLabel.due}}</label></li>
        <li class="notes-column">
            <p><label>{{locoLabel.notes}}</label></p>
        </li>
        <li><label>{{locoLabel.remarks}}</label></li>
        <li><label>{{locoLabel.runDeadiso}}</label></li>
        <li><label>{{locoLabel.tag}}</label></li>
        <li><label>{{locoLabel.direction}}</label></li>
        <li><label>{{locoLabel.class}}</label></li>
        <li><label>{{locoLabel.tractiveEffort}}</label></li>
        <li><label>{{locoLabel.horsePower}}</label></li>
        <li><label>{{locoLabel.assignCurrent}}</label></li>
        <li><label>{{locoLabel.location}}</label></li>
        <li><label>{{locoLabel.plannedAssignment}}</label></li>
        <li><label>{{locoLabel.pickupAt}}</label></li>
    </ul>
</div>